export const thumb = (filename, width, height) =>
    `//media.strongproject.com/r/${width}x${height}/${filename}`;

export const scale = (img, opt={}) => {
    let s
    if (opt.width)
        s = img.height/img.width*opt.width
    if (opt.height)
        s = img.width/img.height*opt.height
    if (s)
        return Math.floor(s)
}
export const scaled = (img, opt={}) => {
    if (!opt.width && !opt.height)
        opt.height = Math.min(1000, img.height, window.innerHeight)
    if (opt.width)
        return thumb(img.filename, opt.width, scale(img, opt))
    if (opt.height)
        return thumb(img.filename, scale(img, opt), opt.height)
}



// WEBPACK FOOTER //
// ./src/thumbs.js